import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { UpdatePrompt } from './UpdatePrompt';
import { useSettingsStore, useAuthStore } from '@/stores';

export function AppShell() {
  const fetchRemoteSettings = useSettingsStore((s) => s.fetchRemoteSettings);
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    if (token) {
      fetchRemoteSettings();
    }
  }, [token, fetchRemoteSettings]);

  return (
    <div className="flex h-dvh bg-surface">
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0">
        <Header />
        <main className="flex-1 overflow-y-auto pb-20 md:pb-4 px-4">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom nav */}
      <div className="md:hidden">
        <BottomNav />
      </div>

      <UpdatePrompt />
    </div>
  );
}
